"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import Topnav from "@/components/topnav";
import useOrientation from "@/hooks/useOrientation"
import { CloudUpload, FileText, BatteryFull, Image } from "lucide-react"

import Enviar from "./enviar"


const pageVariants = {
  initial: {
    opacity: 0,
    y: 10,
  },

  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
    },
  },

  exit: {
    opacity: 0,
    y: -10,
    transition: {
      duration: 0.3,
    },
  },
}



type UploadForm = {
  title: string
  artist: string
  genre: string
}

export default function Subir() {
  const { isPortrait, isLandscape, isStandalone, isDesktopStandalone } = useOrientation()

  const [step, setStep] = useState(1)

  const [file, setFile] = useState<File | null>(null)

  const [image, setImage] =
    useState<string | null>(null)

  const [progress, setProgress] =
    useState(0)


  const [form, setForm] =
    useState<UploadForm>({
      title: "",
      artist: "",
      genre: "",
    })



  const genres = [
    "Techno",
    "House",
    "Deep House",
    "Tech House",
    "Minimal",
    "Drum & Bass",
    "Dubstep",
    "Electro",
    "Trance",
    "Ambient",
    "Urbano",
    "Breakbeat",
  ]



  const simulateUpload = () => {

    setStep(2)

    let percent = 0

    const interval =
      setInterval(() => {

        percent += 10

        if (percent <= 100) {
          setProgress(percent)
        }
        else {
          clearInterval(interval)
        }

      }, 200)

  }



  const handleFileDrop = (
    e: React.DragEvent<HTMLDivElement>
  ) => {

    e.preventDefault()

    const dropped =
      e.dataTransfer.files[0]

    if (dropped) {

      setFile(dropped)

      simulateUpload()

    }

  }



  const handleFormChange = (
    e:
      React.ChangeEvent<
        HTMLInputElement |
        HTMLSelectElement
      >
  ) => {

    const {
      name,
      value
    } = e.target


    setForm(prev => ({
      ...prev,
      [name]: value
    }))

  }




  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {

    const selected =
      e.target.files?.[0]


    if (selected) {

      setImage(
        URL.createObjectURL(selected)
      )

    }

  }



  const handleSubmit = (
    e: React.FormEvent
  ) => {

    e.preventDefault()

    console.log(
      "Submitting track:",
      file,
      form
    )

    setStep(3)

  }



  return (

<div className="
      relative w-full h-[100dvh]
      overflow-hidden overscroll-none
      touch-pan-y">
    <Topnav />

    <div
      className={`
      relative
      w-full
      overflow-hidden
      ${isLandscape
                ?
                "bg-[var(--movil-nav)] h-[calc(100%-3.7rem)] border border-white/15 rounded-xl" : ""}
            
      ${isPortrait
                ? "h-[100dvh]" : ""}
            
      ${isStandalone
                ? "h-[100dvh] mb-0 pt-15" : ""}
       `}
    >


    

      <motion.div
        className={` inset-0
        
          select-none relative
          overflow-y-none
          overscroll-none
          h-full
          w-full
          flex
          flex-col
          p-4
          text-[var(--primary-color)]
          rounded-xl 
        ${isLandscape ? "" : ""}
        ${isPortrait ? "pt-15" : "" }
        ${isStandalone ? "" : "" }
      `}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit">

        {/* TOP META */}
        <div
          className="
            grid
            grid-cols-[auto_1fr_auto]

            items-center
            gap-3

            border
            border-dashed
            border-white/10
            bg-white/[0.08]
            p-3
            rounded-xl
            mb-4
            ">
          <div
            className="
            text-3xl
            text-[var(--primary-color)]/70
            ">
            {/* ◌ */}<BatteryFull className="w-8 h-8 opacity- 100 text-[var(--primary-color)]" />
          </div>



          <div>

            <p
              className="
text-xs
text-[var(--primary-color)]/80
"
            >
              0% de subidas usado
            </p>


            <p
              className="
text-xs
text-[var(--primary-color)]/50
"
            >
              Máximo:120 min
            </p>


          </div>



          <Link
            to="/publicar"
          >

            <button

              className="
flex
items-center
gap-1

bg-white/90

px-3
py-2

rounded-lg

text-[var(--background)]

text-xs

font-bold

active:scale-95

transition

"

            >

              ↑ SUBIDAS

            </button>

          </Link>



        </div>




        <div
          className="
mb-4
"
        >

          <h2

            className="
text-xl
font-bold
mb-1
"

          >

            Sube tus archivos de audio.

          </h2>


          <p

            className="
text-xs
text-[var(--primary-color)]/60
leading-tight
"

          >

            Para obtener un mejor rendimiento,
            utiliza MP3 o M4a.
            El tamaño máximo del archivo es 1GB.
            Duración máxima:120 minutos.

          </p>


        </div>


        {/* =====================
          STEP 1
      ====================== */}

        {step === 1 && (

          <>

            <div

              onDrop={handleFileDrop}

              onDragOver={(e) =>
                e.preventDefault()
              }

              /* className="
          border
          border-dashed
          border-white/30

          rounded-xl

          p-10

          flex
          flex-col
          items-center
          justify-center

          text-center

          bg-black/20

          transition

          active:border-white/60
        " */

        className={`
        border
          border-dashed
          border-white/30

          rounded-xl

          p-10

          flex
          flex-col
          items-center
          justify-center

          text-center

          bg-black/20

          transition

          active:border-white/60
        ${isLandscape ? "h-218" : ""}
        ${isPortrait ? "h-95" : "" }
        ${isStandalone ? "h-125" : "" }
      `}

            >


              <div

                className="
            text-5xl
            mb-4
            text-[var(--primary-color)]/70
          "

          

              >

                <CloudUpload className="w-12 h-12 opacity- 100 text-[var(--primary-color)]" />

              </div>



              <p

                className="
            text-sm
            text-[var(--primary-color)]/65
            leading-tight
          "

              >

                Arrastra y suelta archivos
                <br />
                de audio para empezar.

              </p>




              <label
                className="
                mt-5
                px-6
                py-3
                rounded-full
                bg-[var(--primary)]/20
                text-[var(--primary)]
                font-semibold
                cursor-pointer
                active:scale-95
                transition
              "
                
                  >
                  
                    Elegir archivos
                
                
                    <input
    
                      type="file"
                
                      accept="
                .mp3,
                .wav,
                .aac,
                .ogg,
                .flac,
                audio/*
                "

                  hidden


                  onChange={(e) => {

                    const selected =
                      e.target.files?.[0]


                    if (selected) {

                      setFile(selected)

                      simulateUpload()

                    }

                  }}

                />


              </label>


            </div>





            <div
            className={`
                absolute
                bottom-4
                left-4
                right-4
                z-50

                grid
                grid-cols-[auto_1fr]

                gap-2
                items-center

                border
                border-dashed
                border-white/10

                bg-white/[0.08]

                backdrop-blur-xl

                p-3       
                rounded-xl
        ${isLandscape ? "" : ""}
        ${isPortrait ? "mb-20" : "" }
        ${isStandalone ? "" : "" }
      `}
            >
              <FileText className="w-3 h-3 opacity- 100 text-[var(--primary-color)]" />

              <Link
                to="/terms"
                className="
                  text-xs
                  text-[var(--primary-color)]/70
                "
              >
                Términos y Condiciones
              </Link>
            </div>


          </>

        )}






        {/* =====================
          STEP 2
      ====================== */}

        {step === 2 && (


          <div

            className="
        bg-[var(--soft-bg)]
        border border-[var(--soft-border)]
        rounded-xl
        p-4
      "

          >



            <div

              className="
          flex
          justify-between

          text-xs

          text-[var(--primary-color)]/60

          mb-3
        "

            >

              <span>
                {progress}% de subidas usado
              </span>

              <span>
                Max:120min
              </span>


            </div>





            {/* PROGRESS */}

            <div

              className="
          h-3
          rounded-full
          bg-[var(--soft-bg)]
          border border-[var(--soft-border)]
          overflow-hidden
          mb-6
        "

            >

              <div

                className="
            h-full
            bg-emerald-500
            transition-all

          "

                style={{
                  width: `${progress}%`
                }}
              />
            </div>


            {/* IMAGE PICKER */}
            <div

              className="
          flex
          justify-center

          mb-6

        "

            >

              <label

                className="
          w-35
          h-35
          rounded-xl

          bg-[var(--soft-bg)]
          border border-dashed border-[var(--soft-border)]

          flex
          items-center
          justify-center

          cursor-pointer

          overflow-hidden

        "

              >


                {image ? (
                  <img
                    src={image}
                    alt="preview"
                    className="
                      w-full
                      h-full
                      object-cover
                    "/>
                ) : (
                  <span
                    className="
                      text-4xl
                      text-[var(--primary-color)]/50
                    ">
                    <Image className="w-12 h-12 opacity-30" />
                  </span>
                )}

                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleImageChange}
                />
              </label>
            </div>

            {/* FORM */}
            <form
              onSubmit={handleSubmit}
              className="
                flex
                flex-col
                gap-4
              ">
              <div>
                <label
                  className="
                    block
                    mb-2

                    text-sm
                    text-[var(--primary-color)]/60
                  ">
                  Título de la pista *
                </label>
                <input
                  type="text"
                  name="title"
                  value={form.title}

                  onChange={handleFormChange}

                  required


                  className="
                    w-full
                    rounded-lg
                    bg-[var(--soft-bg)]
                    border border-[var(--soft-border)]

                    px-3
                    py-2
                    text-[var(--primary-color)]

                    outline-none

                  "

                />


              </div>





              <div>

                <label

                  className="
          block
          mb-2

          text-sm
          text-[var(--primary-color)]/60

        "

                >

                  Artista(s) principal(es) *

                </label>


                <input

                  type="text"

                  name="artist"

                  value={form.artist}

                  onChange={handleFormChange}

                  required


                  className="
          w-full

          rounded-lg

          bg-[var(--soft-bg)]
          border border-[var(--soft-border)]

          px-3
          py-2

          text-[var(--primary-color)]

        "

                />


              </div>


              <div>

                <label
                  className="
                    block
                    mb-2
                    text-sm
                    text-[var(--primary-color)]/60
                  "
                >
                  Género
                </label>
                <select
                  name="genre"
                  value={form.genre}
                  onChange={handleFormChange}
                  className="
                    w-full
                    rounded-lg
                    bg-[var(--soft-bg)]
                    border border-[var(--soft-border)]
                    px-3
                    py-2
                    text-[var(--primary-color)]
                  "
                >
                  <option value="">
                    Seleccionar...
                  </option>
                  {genres.map((genre) => (
                    <option
                      key={genre}
                      value={genre}
                    >
                      {genre}
                    </option>
                  ))}
                </select>
              </div>

              <button
                type="submit"

                className="
                  mt-3
                  rounded-full
                  bg-emerald-500
                  py-3
                  font-bold
                  text-[var(--primary-color)]
                  active:scale-95
                  transition
                "
              >
                Subir
              </button>
            </form>
          </div>
        )}



      {/* =====================
          STEP 3
      ====================== */}
        {step === 3 && (
          <Enviar
            trackData={{
              file,
              image,
              ...form,
            }}
          />
        )}

      </motion.div>

    </div>
    </div>
  )
}